import { render, staticRenderFns } from "./PatientSocialHistoryCard.vue?vue&type=template&id=c95fcb80&scoped=true&"
import script from "./PatientSocialHistoryCard.vue?vue&type=script&lang=js&"
export * from "./PatientSocialHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientSocialHistoryCard.vue?vue&type=style&index=0&id=c95fcb80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95fcb80",
  null
  
)

export default component.exports